import { useEffect, useRef } from "react";

const ConfettiBG = () => {
	const canvasRef = useRef(null);
	let W = window.innerWidth;
	let H = window.innerHeight;

	useEffect(() => {
		const canvas = canvasRef.current;
		const context = canvas.getContext("2d");
		const maxConfettis = 25;
		const particles = [];
		const possibleColors = ["#ff7336", "#f9e038", "#02cca4", "#383082", "#fed3f5", "#b1245a", "#f2733f"];

		function randomFromTo(from, to) {
			return Math.floor(Math.random() * (to - from + 1) + from);
		}

		function ConfettiParticle() {
			this.x = Math.random() * W; // x
			this.y = Math.random() * H - H; // y
			this.r = randomFromTo(11, 33); // radius
			this.d = Math.random() * maxConfettis + 11;
			this.color = possibleColors[Math.floor(Math.random() * possibleColors.length)];
			this.tilt = Math.floor(Math.random() * 33) - 11;
			this.tiltAngleIncremental = Math.random() * 0.07 + 0.05;
			this.tiltAngle = 0;

			this.draw = function () {
				context.beginPath();
				context.lineWidth = this.r / 2;
				context.strokeStyle = this.color;
				context.moveTo(this.x + this.tilt + this.r / 3, this.y);
				context.lineTo(this.x + this.tilt, this.y + this.tilt + this.r / 5);
				context.stroke();
			};
		}

		function drawConfetti() {
			requestAnimationFrame(drawConfetti);
			context.clearRect(0, 0, W, H);

			for (let i = 0; i < maxConfettis; i++) {
				particles[i].draw();
			}

			let particle = {};
			let remainingFlakes = 0;
			for (let i = 0; i < maxConfettis; i++) {
				particle = particles[i];

				particle.tiltAngle += particle.tiltAngleIncremental;
				particle.y += (Math.cos(particle.d) + 3 + particle.r / 2) / 5;
				particle.tilt = Math.sin(particle.tiltAngle - i / 3) * 15;

				if (particle.y <= H) remainingFlakes++;

				if (particle.x > W + 30 || particle.x < -30 || particle.y > H) {
					particle.x = Math.random() * W;
					particle.y = -30;
					particle.tilt = Math.floor(Math.random() * 10) - 20;
				}
			}

			if (remainingFlakes === 0) {
				context.clearRect(0, 0, W, H);
			}
		}

		const handleResize = () => {
			W = window.innerWidth;
			H = window.innerHeight;
			canvas.width = window.innerWidth;
			canvas.height = window.innerHeight;
		};

		window.addEventListener("resize", handleResize);

		// Create confetti particles
		for (let i = 0; i < maxConfettis; i++) {
			particles.push(new ConfettiParticle());
		}

		// Initialize canvas size and draw confetti
		canvas.width = W;
		canvas.height = H;
		drawConfetti();

		// Clean up event listener on component unmount
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	return <canvas ref={canvasRef} className="z-[0] overflow-hidden w-full h-full absolute top-0 pointer-events-none"></canvas>;
};


export default ConfettiBG;